import { toastController } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { type ToastOptions } from '@ionic/core';

const TOAST_DURATION = 1500;

// Custom Slide-in Animation
// const slideInAnimation = (baseEl: HTMLElement) => {
//   const root = baseEl.shadowRoot!;
//   const toast = root.querySelector('.toast-wrapper') as HTMLElement;

//   return createAnimation()
//     .addElement(toast)
//     .duration(200)
//     .keyframes([
//       { offset: 0, transform: 'translateY(100%)', opacity: '0' },
//       { offset: 1, transform: 'translateY(-80px)', opacity: '1' },
//     ]);
// };

// // Custom Fade-out Animation
// const fadeOutAnimation = (baseEl: HTMLElement) => {
//   const root = baseEl.shadowRoot!;
//   const toast = root.querySelector('.toast-wrapper') as HTMLElement;

//   return createAnimation()
//     .addElement(toast)
//     .duration(200)
//     .keyframes([
//       { offset: 0, opacity: '1', transform: 'translateY(-80px)' },
//       { offset: 1, opacity: '0', transform: 'translateY(100%)' },
//     ]);
// };

export function useAppToasts() {
  const { t } = useI18n();

  const raiseErrorToast = async (message?: string, options?: ToastOptions) => {
    const toast = await toastController.create({
      message: message ?? t('generic_error_msg_text'),
      duration: TOAST_DURATION,
      position: 'top',
      color: 'danger',
      cssClass: ' text-center custom-toast',
      // enterAnimation: slideInAnimation,
      // leaveAnimation: fadeOutAnimation,
      ...options,
    });
    await toast.present();
  };

  const raiseSuccessToast = async (message?: string, options?: ToastOptions) => {
    const toast = await toastController.create({
      message: message ?? t('generic_success_msg_text'),
      duration: TOAST_DURATION,
      position: 'top',
      color: 'success',
      cssClass: 'text-center custom-toast',
      // enterAnimation: slideInAnimation,
      // leaveAnimation: fadeOutAnimation,
      ...options,
    });
    await toast.present();
  };

  return { raiseErrorToast, raiseSuccessToast };
}
export const toastConsoleLog = async (message?: string, options?: ToastOptions) => {
  const toast = await toastController.create({
    message: message,
    duration: TOAST_DURATION,
    position: 'top',
    color: 'success',
    cssClass: 'text-center custom-toast',
    // enterAnimation: slideInAnimation,
    // leaveAnimation: fadeOutAnimation,
    ...options,
  });
  await toast.present();
};
